/**
 * useMailboxItem — subscribes to Office.EventType.ItemChanged
 * so the taskpane updates when the user switches emails.
 */
import { useState, useEffect, useCallback } from "react";
import { readCurrentEmail } from "../../services/emailReader";

/* global Office */

export function useMailboxItem() {
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadEmail = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await readCurrentEmail();
      setEmail(data);
    } catch (err) {
      console.error("Failed to read email:", err);
      setError(err.message || "Unable to read email");
      setEmail(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Load initial email
    loadEmail();

    // Subscribe to item changes
    try {
      Office.context.mailbox.addHandlerAsync(
        Office.EventType.ItemChanged,
        () => loadEmail()
      );
    } catch (err) {
      console.warn("ItemChanged subscription not supported:", err);
    }

    // Cleanup
    return () => {
      try {
        Office.context.mailbox.removeHandlerAsync(Office.EventType.ItemChanged);
      } catch {
        // Ignore cleanup errors
      }
    };
  }, [loadEmail]);

  return { email, loading, error, reload: loadEmail };
}

export default useMailboxItem;
